/*
 * Search autocomplete terms, shared by every search surface.
 *
 * Kept apart from SearchMap so pages that are not the map (/search,
 * /pampers-club/search) can use the list without pulling in leaflet.
 */

import theklaLogo from "../../assets/thekla-logo.png";
import bibebaLogo from "../../assets/bibeba-logo.png";
import babystepsLogo from "../../assets/baby-steps-logo.png";
import mawibaLogo from "../../assets/mawiba-logo.png";
import guldenLogo from "../../assets/gulden-logo.png";
import trageschuleLogo from "../../assets/kikudoo-trageschule-hamburg.png";
import pekipLogo from "../../assets/pekip-logo.png";

export const SUGGESTIONS = [
  { name: "Elke Gulden Institut", image: guldenLogo },
  { name: "Trageschule Hamburg", image: trageschuleLogo },
  { name: "BiBeBa", image: bibebaLogo },
  { name: "Einfach Eltern", image: babystepsLogo },
  { name: "MAWIBA", image: mawibaLogo },
  { name: "PEKiP", image: pekipLogo },
  { name: "THEKLA - Thüringer Eltern Kind Lern- & Aktivkurs", image: theklaLogo },
  { name: "Rückbildung" },
  { name: "Entwicklungsbegleitung" },
  { name: "Kinder" },
  { name: "Skating" },
  { name: "Bildung" },
  { name: "Gymnastik" },
  { name: "Beikostberatung" },
  { name: "Schlafcoaching" },
  { name: "Faszien" },
  { name: "Digital" },
  { name: "CANTIENICA®" },
  { name: "Feldenkrais" },
  { name: "Meditation" },
  { name: "Hypnose" },
  { name: "Ernährungsberatung" },
  { name: "Osteopathie" },
  { name: "Wochenbett" },
  { name: "Hypnobirthing" },
  { name: "Doula" },
  { name: "Kindersicherheit" },
  { name: "Beckenboden" },
  { name: "Sternenkinder" },
  { name: "Babymassage" },
  { name: "Baby" },
  { name: "Basteln" },
  { name: "Body-Mind Centering®" },
  { name: "Beratung" },
  { name: "DELFI" },
  { name: "Draußen" },
  { name: "Early English" },
  { name: "Coaching" },
  { name: "ELBA" },
  { name: "Entspannung" },
  { name: "Erziehungsbegleitung" },
  { name: "Ernährung" },
  { name: "Familie" },
  { name: "Fabel" },
  { name: "FENKID" },
  { name: "Förderung" },
  { name: "Geburtsvorbereitung" },
  { name: "Hebammen" },
  { name: "Krabbelgruppe" },
  { name: "Kreativität" },
  { name: "Massage" },
  { name: "Erste-Hilfe" },
  { name: "Geburtstag" },
  { name: "Gesundheit" },
  { name: "KANGA" },
  { name: "Kita" },
  { name: "Kunst" },
  { name: "Lernen" },
  { name: "Motopädie" },
  { name: "Malen" },
  { name: "Musik" },
  { name: "Online-Seminar" },
  { name: "Physiologie" },
  { name: "Psychologie" },
  { name: "Pilates" },
  { name: "Säugling" },
  { name: "Schwangere" },
  { name: "Schwimmen" },
  { name: "Selbstverteidigung" },
  { name: "Singen" },
  { name: "Pikler" },
  { name: "Spa" },
  { name: "Sport" },
  { name: "Sprachen" },
  { name: "Stillberatung" },
  { name: "Tanzen" },
  { name: "Theater" },
  { name: "Spielen" },
  { name: "Töpfern" },
  { name: "Turnen" },
  { name: "Veranstaltung" },
  { name: "Verstehen" },
  { name: "Walking" },
  { name: "Werkstatt" },
  { name: "Yoga" },
  { name: "Yoga mit Kind" },
  { name: "Trageberatung" },
  { name: "Workshop" },
  { name: "Wasserspaß" },
  { name: "Sprachförderung" },
  { name: "THEKLA" },
  { name: "Unfallprävention" },
  { name: "Geschwister" },
  { name: "PreKanga" },
  { name: "Mawiba" },
  { name: "Kindersport" },
  { name: "Musikgarten" },
  { name: "BabySteps" },
  { name: "Babyschwimmen" },
  { name: "Akupunktur" },
  { name: "Kinderschwimmen" },
  { name: "Shiatsu" },
  { name: "Sonstiges" },
  { name: "Babyfotos" },
  { name: "nappydancers®" },
  { name: "babySignal" },
  { name: "FamilySteps" },
  { name: "BiBeBa" },
  { name: "Stoffwindelberatung" },
  { name: "Babyzeichensprache" },
  { name: "artgerecht®" },
  { name: "Musikalische Früherziehung" },
  { name: "Wobbelturnen" },
  { name: "Fit mit Kind" },
  { name: "Dunsten" },
  { name: "Babyschlaf" },
  { name: "Picky Eaters" },
];
